import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  plan: null,
  wplan: null,
  is_open: null,
  collabs: null,
  collabs_plan: null,
  comments: []
}

const mutations = {
  SET_PLAN (state, payload) {
    state.plan = payload
  },
  SET_WPLAN (state, payload) {
    state.wplan = payload
  },
  SET_ISOPEN (state, payload) {
    state.is_open = payload
  },
  CLEAN (state) {
    state.plan = null
    state.wplan = null
    state.is_open = null
  },
  SET_COLLABS_PLAN (state, payload) {
    state.collabs_plan = payload
  },
  SET_COMMENTS (state, payload) {
    state.comments = payload
  },
  SET_COLLABS (state, payload) {
    state.collabs = payload
  },
  ADD_COMMENT (state, payload) {
    state.comments.unshift(payload)
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  }
}

const actions = {
  create: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-lider`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  byPlanConId: (context, id) => {
    return Vue.http.get(`${env.API}/api/plan-lider/${id}`)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  planByWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-lider/by-week`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  planUpdate: (context, data) => {
    return Vue.http.put(`${env.API}/api/plan-lider/${data.id}`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  closePlanificationStage: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-lider/close`, data)
      .then((response) => {
        context.commit('SET_PLAN', response.body.message)
        return response.body
      })
      .catch((error) => {
        console.log(error)
        return context.commit('API_FAILURE', error)
      })
  },
  planIsOPenByWeek: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-lider/by-week/is-open`, data)
      .then((response) => {
        context.commit('SET_ISOPEN', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  cleanStorePlan: (context) => {
    context.commit('CLEAN')
    return
  },
  generateWeeklyReport: (context, data) => {
    const { week, year } = data
    return Vue.http.get(`${env.API}/api/plan-lider/users-report/${week}/${year}`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  collabsPlanWeekInfo: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-lider/collabs-week-information`, data)
      .then((response) => {
        context.commit('SET_COLLABS_PLAN', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  addComment: (context, data) => {
    return Vue.http.post(`${env.API}/api/plan-lider/add-comment`, data)
      .then((response) => {
        context.commit('ADD_COMMENT', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createIfDontExist: (context, id) => {
    return Vue.http.get(`${env.API}/api/plan-lider/create-exists/${id}`)
      .then((response) => {
        context.commit('SET_COLLABS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getCommentsByPLanId: (context, data) => {
    let {id, type} = data
    return Vue.http.get(`${env.API}/api/plan-lider/get-comments/${id}/type/${type}`)
      .then((response) => {
        context.commit('SET_COMMENTS', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getPlan: (state) => state.plan,
  getWPlan: (state) => state.wplan,
  getPlanIsOpen: (state) => state.is_open,
  getCollabs: (state) => state.collabs,
  getCollabsPlan: (state) => state.collabs_plan,
  getComments: (state) => state.comments
}

export const plan_lider = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/plan_lider.js